import React from 'react';
import { BooleanInput, Create, email, number, ReferenceInput, required, SelectInput, SimpleForm, TextInput, NumberInput } from 'react-admin';
import { invoiceVoucherTypeForSelection } from './InvoiceVoucherConstants';

const validateAmount = [required(), number()];
const InvoiceVoucherCreate = (props) => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<TextInput source="emailAddress" validate={email()} />
			<TextInput source="marketingAction" validate={required()} />
			<TextInput source="amount.amount" validate={validateAmount} />
			<ReferenceInput variant="standard" source="amount.currency" reference="currencies" validate={required()}>
				<SelectInput optionText="name" resettable />
			</ReferenceInput>
			<SelectInput source="type" choices={invoiceVoucherTypeForSelection} />
			<TextInput source="description" validate={required()} />
			<NumberInput variant="standard" source="systemAccountId" validate={required()} />
			<BooleanInput label="resources.invoiceVouchers.fields.activate" source="activate" />
		</SimpleForm>
	</Create>
);

export default InvoiceVoucherCreate;
